import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Apps, SupportTicketList, SupportTicketTitle } from "../../../Constants/Constants";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { SupportTicketSubTitle } from "../../../Data/Miscellaneous/SupportTicket";
import TicketList from "./TicketList";
import TicketTable from "./TicketTable";

const SupportTicketContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={SupportTicketTitle} parent={Apps} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={SupportTicketList} span={SupportTicketSubTitle} tag />
              <CardBody>
                <TicketList />
                <TicketTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SupportTicketContainer;
